import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
// import Adal from 'vue-adal'
import msal from 'vue-msal'
import msalMixin from 'vue-msal'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vidle from 'v-idle'

import App from './App.vue'
import router from './router/index.js'
import store from './store'
import axios from 'axios'

var RhsTreatmentPlanRequestHandlingApiV2 = require('rhs-treatment-plan-request-handling-api-v2');
var RhsBranchUserHospitalApiV2 = require('rhs-branch-user-hospital-api-v2-legacy');
var RhsPatientInformationApiV2 = require('rhs-patient-information-api-v2');
var SiassPatientScanProvisioningApiV1 = require('siass-patient-scan-provisioning-api-v1');
var RhsPatientScanViewerProvisioningApiV2 = require('rhs-patient-scan-viewer-provisioning-api-v2');
var RhsSurgicalCaseApiV2 = require('rhs-surgical-case-api-v2');
var RhsTreatmentPlanProvisioningApiV2 = require('rhs-treatment-plan-provisioning-api-v2');

// Handle fontawesome icons
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.config.productionTip = false

// Instantiate API Clients for RHS and make them available via Instance Properties
var tprhClient = RhsTreatmentPlanRequestHandlingApiV2.ApiClient.instance;
var piClient = RhsPatientInformationApiV2.ApiClient.instance;
var pspClient = SiassPatientScanProvisioningApiV1.ApiClient.instance;
var scClient = RhsSurgicalCaseApiV2.ApiClient.instance;
var tppClient = RhsTreatmentPlanProvisioningApiV2.ApiClient.instance;
var buhClient = RhsBranchUserHospitalApiV2.ApiClient.instance;
var psvpClient = RhsPatientScanViewerProvisioningApiV2.ApiClient.instance;

// Get configuration file and setup everything accordingly
fetch('/config.json').then(res => res.json()).then(config => {
  // Register plugins
  Vue.use(BootstrapVue)
  Vue.use(BootstrapVueIcons)
  Vue.use(AsyncComputed)
  Vue.use(Vidle)

  // Normalize base path
  const rhsBasePath = config.rhsBasePath.endsWith('/') ? config.rhsBasePath : config.rhsBasePath + "/"
  const mibBasePath = config.mibBasePath.endsWith('/') ? config.mibBasePath : config.mibBasePath + "/"

  let tokenRenewalOffsetSeconds = 2400 // 40 minutes
  if (config.tokenRenewalOffsetSeconds) {
    tokenRenewalOffsetSeconds = config.tokenRenewalOffsetSeconds
  }

  let tokenRefreshIntervallInMilliSec = 240000 // 4 minutes
  if (config.tokenRefreshIntervallInMilliSec) {
    tokenRefreshIntervallInMilliSec = config.tokenRefreshIntervallInMilliSec
  }

  Vue.use(msal, {
    auth: {
      clientId: config.adal.makoSuiteId,
      tenantId: config.adal.tenant,
      redirectUri: config.adal.redirectUri,
      navigateToLoginRequestUrl: false,
      requireAuthOnInitialize: false,
      postLogoutRedirectUri: rhsBasePath + "SignIn",
      autoRefreshToken: false,
      mixins: [msalMixin]
    },
    request: {
      scopes: [`${config.adal.clientId}/.default`]
    },
    cache: {
      storeAuthStateInCookie: true,
      cacheLocation: "localStorage"
    },
    system: {
      tokenRenewalOffsetSeconds: tokenRenewalOffsetSeconds
    },
    framework: {
      globalMixin: true
    }
  });

  tprhClient.basePath = rhsBasePath + "api/v2"
  piClient.basePath = rhsBasePath + "api/v2"
  pspClient.basePath = mibBasePath + "api/v1"
  scClient.basePath = rhsBasePath + "api/v2"
  tppClient.basePath = rhsBasePath + "api/v2"
  buhClient.basePath = rhsBasePath + "api/v2"
  psvpClient.basePath = rhsBasePath + "api/v2"

  axios.defaults.baseURL = rhsBasePath + "api/v2"

  // Check and Set Implant Sets
  if (config.implantSets.tka2.toLowerCase() == "true") {
    Vue.prototype.$tka = "tka2"
  } else {
    Vue.prototype.$tka = "tka1"
  }
  if (config.implantSets.tha4.toLowerCase() == "true") {
    Vue.prototype.$tha = "tha4"
  } else {
    Vue.prototype.$tha = "tha3"
  }
  Vue.prototype.$mckpk = "mckpk"

  // Init API Clients
  Vue.prototype.$treatmentPlanRequestsApi = new RhsTreatmentPlanRequestHandlingApiV2.TreatmentPlanRequestsApi()
  Vue.prototype.$additionalDataApi = new RhsTreatmentPlanRequestHandlingApiV2.AdditionalDataApi()
  Vue.prototype.$treatmentPlanRequestsStateApi = new RhsTreatmentPlanRequestHandlingApiV2.TreatmentPlanRequestsStateApi()

  Vue.prototype.$patientInfoApi = new RhsPatientInformationApiV2.PatientInfoApi()

  Vue.prototype.$buhApi = new RhsBranchUserHospitalApiV2.BranchApi()
  Vue.prototype.$buhBulkApi = new RhsBranchUserHospitalApiV2.BulkImportApi()
  Vue.prototype.$buhUserApi = new RhsBranchUserHospitalApiV2.UserApi()

  Vue.prototype.$patientScansProvisioningApi = new SiassPatientScanProvisioningApiV1.PatientScansApi()
  Vue.prototype.$patientScansMetadataApi = new SiassPatientScanProvisioningApiV1.PatientScansMetadataApi()

  Vue.prototype.$patientScanViewerProvisioningApi = new RhsPatientScanViewerProvisioningApiV2.PatientScanViewerProvisioningApi()

  Vue.prototype.$treatmentPlanProvisioningApi = new RhsTreatmentPlanProvisioningApiV2.TreatmentPlanApi()
  Vue.prototype.$treatmentPlanMetadataApi = new RhsTreatmentPlanProvisioningApiV2.TreatmentPlanMetadataApi()

  Vue.prototype.$surgicalCaseApi = new RhsSurgicalCaseApiV2.SurgicalCaseApi()

  Vue.prototype.$tprhClient = tprhClient
  Vue.prototype.$buhClient = buhClient
  Vue.prototype.$piClient = piClient
  Vue.prototype.$pspClient = pspClient
  Vue.prototype.$tppClient = tppClient
  Vue.prototype.$scClient = scClient
  Vue.prototype.$psvpClient = psvpClient

  Vue.prototype.$makoSuiteId = config.adal.makoSuiteId
  Vue.prototype.$redirectUri = config.adal.redirectUri
  Vue.prototype.$version = config.version
  Vue.prototype.$solidUrl = config.solidUrl
  Vue.prototype.$shareScanBranchExternalReferencesBlackList = config.shareScanBranchExternalReferencesBlackList

  // Set AFK config
  const idleWarningTimeInMilliSec = config.idleWarningTimeInMilliSec ? config.idleWarningTimeInMilliSec : 300000
  const idleTime = config.idleTimeInMilliSec ? config.idleTimeInMilliSec / 1000 : 3600
  const updateScansWithLoadingStatusInSeconds = config.updateScansWithLoadingStatusInSeconds ? parseInt(config.updateScansWithLoadingStatusInSeconds) : 5
  const updateAllScansInSeconds = config.updateAllScansInSeconds ? parseInt(config.updateAllScansInSeconds) : 60
  Vue.prototype.$tokenRefreshIntervallInMilliSec = tokenRefreshIntervallInMilliSec
  Vue.prototype.$idleWarningTimeInMilliSec = idleWarningTimeInMilliSec
  Vue.prototype.$idleTime = idleTime
  Vue.prototype.$updateScansWithLoadingStatusInSeconds = updateScansWithLoadingStatusInSeconds
  Vue.prototype.$updateAllScansInSeconds = updateAllScansInSeconds

  new Vue({
    router,
    store,
    render: h => h(App, {
    })
  }).$mount('#app')
})

